import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import {graphql} from 'gatsby';
import SEO from './SEO';
// import '../styles/style.main.min.css';
import * as styles from './Styles/staticpage.module.scss';
import Footer from './Shared/Footer';
import Header from './Shared/Header';
import htmr from 'htmr';
import {Nav, Tab} from 'react-bootstrap';
import EmployeeTabComponent from './Shared/EmployeeTabComponent';
import {
  data as pageDataJSON,
} from '../data/staticPageData.json';
import {getCanonicalPages} from './Shared/Utils';

const StaticPage = ({data}) => {
  const canonicalPages = getCanonicalPages(
      data.brandWebsiteStaticwebpage.url,
  );
  const pageData = {
    ...data,
    ...pageDataJSON,
    canonicalPages,
  };
  const headerContent = pageData.brandWebsiteHeader;
  const footerContent = pageData.brandWebsiteFooter;
  const homePage = pageData.brandWebsiteStaticwebpage;
  const pageslug=homePage.pageslug+' container';
  const pageImage=homePage.seo.image;
  const pageImageUrl=pageImage?pageImage.href:'';

  const handleScroll = () => {
    const images = document.getElementsByTagName('img');
    Array.from(images).forEach((img) => {
      if (img.dataset.src && img.src.indexOf(img.dataset.src) <= -1) {
        img.src = img.dataset.src;
      }
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const languageCanonicals = pageData.canonicalPages;

  const canonicalList=homePage.seo.canonicalurls;
  const canonicalUrls=[];
  if (canonicalList) {
    for (let index=0; index<canonicalList.length; index++) {
      canonicalUrls.push({
        'href': canonicalList[index].href,
        'rel': 'canonical',
      });
    }
  }

  return (
    <div>
      <SEO
        locale={homePage.locale}
        title={homePage.seo.title}
        description={homePage.seo.description}
        image={pageImageUrl}
        canonicalUrls={canonicalUrls}
        languageCanonicals={languageCanonicals}
        siteMetadata={pageData.site.siteMetadata}
        schemaMarkup={JSON.parse(homePage.schema)}
      />
      <Helmet>
        <script>
          window.dataLayer=window.dataLayer||[];
        </script>
      </Helmet>
      <Header headerContent={headerContent} locale={homePage.locale}/>
      <main className={`${pageslug} ${styles.staticPage}`}>
        {homePage.sections.map((section, sectionIndex) => {
          let content= '<div></div>';
          if (section.pagesection) {
            content=section.pagesection.content;
          }
          if (section.teamsection) {
            const defaultTab=
            section.teamsection?.group?.[0]?.tablabel?.toLowerCase();
            return (
              <section key={sectionIndex} className={styles.people}>
                <div className={styles.teamHeader}>
                  <h3>Meet</h3>
                  <h1>{section.teamsection.heading}</h1>
                </div>
                <div className={styles.teamDescription}>
                  <p>
                    {section.teamsection.description}
                  </p>
                </div>
                <Tab.Container defaultActiveKey={defaultTab}>
                  <div className={styles.content}>
                    <div className={styles.tabHeader}>
                      <Nav variant="tabs" as="ul">
                        {section.teamsection.group.map((group, index) => (
                          <Nav.Item as="li" key={index}>
                            <Nav.Link
                              eventKey={group.tablabel?.toLowerCase()}>
                              <span>{group.tablabel}</span>
                            </Nav.Link>
                          </Nav.Item >
                        ))}
                      </Nav>
                      <p className={styles.faint}></p>
                    </div>
                    <Tab.Content>
                      {section.teamsection.group.map((group, index) => (
                        <Tab.Pane key={index}
                          eventKey={group.tablabel.toLowerCase()}>
                          <EmployeeTabComponent
                            showMoreText={section.teamsection.showmoretext}
                            members={group.members} />
                        </Tab.Pane>),
                      )}
                    </Tab.Content>
                  </div>
                </Tab.Container>
              </section>
            );
          }
          return (htmr(content));
        })}
      </main>
      <Footer footerData={footerContent}
        siteMetadata={pageData.site.siteMetadata} />
    </div>
  );
};
StaticPage.defaultProps = {
  data: {},
};

StaticPage.propTypes = {
  data: PropTypes.object,
};
export default StaticPage;

export const pageQuery = graphql`
  query StaticPageID($id: String) {
    brandWebsiteStaticwebpage(id: { eq: $id }) {
      url
      locale
      title
      pageslug
      sections{
        pagesection {
          title
          content
        }
        teamsection {
          heading
          showmoretext
          description
          group {
            tablabel
            members {
              membertitle
              membername
              memberbio
              memberimage {
                title
                href
              }
            }
          }
        }
      }      
      seo{
        title
        description
        image {
          title
          href
        }
        canonicalurls {
          title
          href
        }
      }
      schema      
    }
    site {
      siteMetadata {
        title
        siteUrl
        description
        social {
          twitter
          facebook
          instagram
          linkedIn
        }
      }
    }
  }
`;
